"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPaginationNumberItem = void 0;
var _PaginationNumberItem = require("./PaginationNumberItem");
// TODO: in v9, move styled() from PaginationNumberItem.jsx to here
var StyledPaginationNumberItem = _PaginationNumberItem.PaginationNumberItem;
exports.StyledPaginationNumberItem = StyledPaginationNumberItem;